import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, viewChild} from '@angular/core';
import {SubProjectDaoService} from '../../../kluh-manager/main/r2-cloud-admin/r2-cloud-admin-sub-project/sub-project-dao.service';
import {ManagerUserDaoService} from '../../../kluh-manager/main/manager-user/manager-user-dao.service';
import {CustomerDaoService} from '../../../kluh-manager/main/customer/customer-dao.service';
import {DesktopServerDaoService} from '../../../kluh-manager/main/desktop-server/desktop-server-dao.service';
import {LinuxServerDaoService} from '../../../kluh-manager/main/linux-server/linux-server-dao.service';
import {debounceTime, distinctUntilChanged, startWith} from 'rxjs/operators';
import {ComponentCleaner} from '../../../kluh-manager/component-cleaner';
import {FormControl} from '@angular/forms';
import {faLinux, faWindows} from '@fortawesome/free-brands-svg-icons';
import {RemoteAppDaoService} from '../../../kluh-manager/main/remote-app/remote-app-dao.service';
import {guessImageMime} from '../../../kluh-manager/helpers/kluh';
import {R2CloudAdminService} from '../../../kluh-manager/main/r2-cloud-admin/r2-cloud-admin.service';
import {Router} from '@angular/router';
import {Page} from '../../../kluh-manager/helpers/Page';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import {faBuilding} from '@fortawesome/free-solid-svg-icons/faBuilding';
import {R2CloudStompService} from '../../../kluh-manager/ws/r2-cloud-stomp.service';
import {ImageFileService} from '../../../kluh-manager/main/image-file/image-file-service';
import {
    CustomerSearchResult,
    DesktopServerSearchResult,
    LinuxServerSearchResult,
    ManagerUserSearchResult,
    RemoteAppSearchResult,
    SubProjectSearchResult
} from '../../../kluh-manager/main/search-result-models';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchComponent extends ComponentCleaner {

    showSuggestions = false;
    selectedItem = 1;
    amountOfItems = 0;
    searchLoading = false;

    desktopServers: DesktopServerSearchResult[] = [];
    remoteApps: RemoteAppSearchResult[] = [];
    linuxServers: LinuxServerSearchResult[] = [];
    subProjects: SubProjectSearchResult[] = [];
    customers: CustomerSearchResult[] = [];
    managerUsers: ManagerUserSearchResult[] = [];
    faWindows = faWindows;
    faLinux = faLinux;
    faUser = faUser;
    faBuilding = faBuilding;
    search = new FormControl<string>('');


    readonly searchInput = viewChild<ElementRef>('searchInput');

    constructor(private subProjectDao: SubProjectDaoService,
                private managerUserDao: ManagerUserDaoService,
                private customerDao: CustomerDaoService,
                private desktopServerDao: DesktopServerDaoService,
                private remoteAppDao: RemoteAppDaoService,
                public imageFileService: ImageFileService,
                private linuxServerDao: LinuxServerDaoService,
                private adminService: R2CloudAdminService,
                private router: Router,
                private stomp: R2CloudStompService,
                private elem: ElementRef,
                private cdr: ChangeDetectorRef) {
        super();

        const search$ = this.search.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            startWith('')
        ).subscribe((result) => {
            if (result) {
                this.onFocusSearch();
                this.searchAllContent(result);
            } else {
                // this.searchSubProject('');
            }
        });
        this.addSubscription(search$);
    }


    public onFocusSearch(): void {
        if (this.search && this.search.value) {
            this.showSuggestions = this.search.value.toString().length > 0;
        }
    }

    public onFocusOutSearch(): void {
        this.showSuggestions = false;
    }


    @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent): void {
        if (this.showSuggestions) {
            if (event.key === 'Enter') {
                const elements = this.elem.nativeElement.querySelectorAll('.active');
                if (elements && elements.length > 0) {
                    const element = elements[0];
                    let typeOfElementSearch;
                    let idOfElementSearch;
                    if (element.childNodes) {
                        for (let i = 0; i < element.childNodes.length; i++) {
                            if (element.childNodes[i].className === 'type') {
                                typeOfElementSearch = element.childNodes[i].innerText;
                            } else if (element.childNodes[i].className === 'id') {
                                idOfElementSearch = element.childNodes[i].innerText;
                            }
                        }
                    }
                    this.openSelected(this.selectedItem, typeOfElementSearch, idOfElementSearch);

                }
            } else if (event.key === 'ArrowUp' && this.selectedItem > 1) {
                this.selectedItem--;
            } else if (event.key === 'ArrowDown' && this.selectedItem < this.amountOfItems) {
                this.selectedItem++;
            }
        }
    }

    public openSelected(itemSelected: number, typeOfElementSearch: string, idOfElementSearch: number): void {
        this.showSuggestions = false;
        this.searchInput()?.nativeElement.blur();
        this.selectedItem = itemSelected;
        const id = +idOfElementSearch;
        if (typeOfElementSearch === 'subProject') {
            this.openSubProject(id);
        } else if (typeOfElementSearch === 'desktopServer') {
            this.openDesktopServer(id);
        } else if (typeOfElementSearch === 'linuxServer') {
            this.openLinuxServer(id);
        } else if (typeOfElementSearch === 'remoteApp') {
            this.openRemoteApp(id);
        } else if (typeOfElementSearch === 'managerUser') {
            this.openCustomerGroup(id);
        } else if (typeOfElementSearch === 'customer') {
            this.openCustomerGroup(id);
        }
    }

    public openSubProject(subProjectId: number): void {
        const subProject = this.subProjects.find(sp => sp.id === subProjectId);
        if (subProject) {
            this.router.navigate(['/admin'], {
                queryParams: {
                    id: subProject.customerGroupId,
                    subProjectId: subProject.id
                }
            });
            this.clearSearch();
        }
    }

    public openDesktopServer(desktopServerId: number): void {
        this.searchLoading = true;
        this.stomp.send('/stomp/open-local-admin', {id: desktopServerId});
        setTimeout(() => {
            this.searchLoading = false;
            this.cdr.markForCheck();
        }, 5000);
    }

    public openRemoteApp(remoteAppId: number): void {
        this.searchLoading = true;
        this.stomp.send('/stomp/open',
            {remoteAppId: remoteAppId});
        setTimeout(() => {
            this.searchLoading = false;
            this.cdr.markForCheck();
        }, 5000);

    }

    public openLinuxServer(linuxServerId: number): void {
        this.searchLoading = true;
        this.stomp.send('/stomp/open-linux-local-admin', {id: linuxServerId});
        setTimeout(() => {
            this.searchLoading = false;
            this.cdr.markForCheck();
        }, 5000);
    }


    public openCustomerGroup(customerGroupId: number): void {
        if (customerGroupId) {
            this.router.navigate(['/register'], {
                queryParams: {
                    id: customerGroupId
                }
            });
            this.clearSearch();
        }
    }


    private searchAllContent(search: string): void {
        this.amountOfItems = 0;
        this.searchSubProject(search);
        this.searchCustomerCNPJ(search);
        this.searchManagerUserEmail(search);
        this.searchDesktopServer(search);
        this.searchLinuxServer(search);
        this.searchRemoteApp(search);
    }


    private searchSubProject(search: string): void {
        this.subProjects = [];
        this.subProjectDao.searchEnriched({fieldOrder: null, order: null, page: null, field: 'name', value: search, limit: 3}).subscribe((result) => {
            this.onSubProjectRequestFinished(result);
        });
    }

    private onSubProjectRequestFinished(result: Page<SubProjectSearchResult>): void {
        if (result && result.content) {
            this.subProjects = result.content;
            this.amountOfItems = this.amountOfItems + result.content.length;
            this.cdr.markForCheck();
        }
    }

    private searchCustomerCNPJ(inSearch: string): void {
        this.customers = [];
        if (inSearch && inSearch.length > 0) {
            const search = inSearch.replace(/\./g, '').replace(/-/g, '').replace('/', '').trim();
            this.customerDao.searchEnriched({
                fieldOrder: undefined as any, order: undefined as any, page: undefined as any,
                field: 'cnpj', value: search, limit: 3
            }).subscribe((result) => {
                if (result && result.content) {
                    this.customers = result.content;
                    this.amountOfItems = this.amountOfItems + result.content.length;
                    this.cdr.markForCheck();
                }
            });
        }
    }

    private searchRemoteApp(search: string): void {
        this.remoteApps = [];
        if (search && search.length > 0) {
            this.remoteAppDao.searchEnriched({fieldOrder: null, order: null, page: null, field: 'name', value: search, limit: 3}).subscribe((result) => {
                if (result && result.content) {
                    this.remoteApps = result.content;
                    this.amountOfItems = this.amountOfItems + result.content.length;
                    this.cdr.markForCheck();
                }
            });
        }
    }

    private searchManagerUserEmail(search: string): void {
        this.managerUsers = [];
        if (search && search.length > 0) {
            this.managerUserDao.searchEnriched({
                fieldOrder: undefined as any, order: undefined as any, page: undefined as any,
                field: 'email', value: search, limit: 3,
            }).subscribe((result) => {
                if (result && result.content) {
                    this.managerUsers = result.content;
                    this.amountOfItems = this.amountOfItems + result.content.length;
                    this.cdr.markForCheck();
                }
            });
        }
    }

    private searchDesktopServer(search: string): void {
        this.desktopServers = [];
        if (search && search.length > 0) {
            this.desktopServerDao.searchEnriched({
                fieldOrder: undefined as any, order: undefined as any, page: undefined as any,
                field: 'hostname,connectionFQDN,publicIp,clientId',
                value: search,
                limit: 3
            }).subscribe((result) => {
                if (result && result.content) {
                    this.desktopServers = result.content;
                    this.amountOfItems = this.amountOfItems + result.content.length;
                    this.cdr.markForCheck();
                }
            });
        }
    }

    private searchLinuxServer(search: string): void {
        this.linuxServers = [];
        if (search && search.length > 0) {
            this.linuxServerDao.searchEnriched({
                fieldOrder: undefined as any, order: undefined as any, page: undefined as any,
                field: 'hostname,connectionFQDN,publicIp,clientId',
                value: search,
                limit: 3
            }).subscribe((result) => {
                if (result && result.content) {
                    this.linuxServers = result.content;
                    this.amountOfItems = this.amountOfItems + result.content.length;
                    this.cdr.markForCheck();
                }
            });
        }
    }

    public guessImageMime(base64: string): string {
        return guessImageMime(base64);
    }

    public clearSearch(): void {
        this.search.setValue('');
    }

}
